module.exports = __webpack_public_path__ + "static/img/activity-scene-1.1c6d23d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-scene-1.jpg
// module id = ZGtn
// module chunks = 10